import React, { Component } from "react";
import { Row, Col } from "antd";
import RcuControlNoChild from "../../components/RcuControls/RcuControlNoChild";
import RcuControlWithChild from "../../components/RcuControls/RcuControlWithChild";

class RcuSmall extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  mainControlRender = () => {
    const { rcuControlStore } = this.props;
    const { makeUpRoom, dnd } = rcuControlStore.deviceControl;
    const { master, masterShowDetail, masterOff } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <RcuControlNoChild
          Title="make.up.room"
          Icon="MakeUpRoomWhite.svg"
          isOn={makeUpRoom}
          onClick={() => rcuControlStore.setMakeUpRoom()}
          ShowSwitchText={true}
        />
        <RcuControlNoChild
          Title="do.not.disturb"
          Icon="DndWhite.svg"
          isOn={dnd}
          onClick={() => rcuControlStore.setDnd()}
          ShowSwitchText={true}
        />
        <RcuControlWithChild
          Title="master"
          Icon="LampOn.png"
          Device={master}
          ShowDetail={masterShowDetail}
          Handlers={{
            turnAllOff: () => rcuControlStore.setMasterAllOff(),
            bright: () => rcuControlStore.setMasterBright(),
            soft: () => rcuControlStore.setMasterSoft(),
            setShowDetail: () => rcuControlStore.setmasterShowDetail(),
          }}
        />
        <RcuControlNoChild
          Title="master.off"
          Icon="LampOn.png"
          isOn={masterOff}
          onClick={() => rcuControlStore.setMasterOff()}
          ShowSwitchText={true}
        />
      </React.Fragment>
    );
  };

  bathroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { bathroom, bathroomShowDetail } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Bathroom</div>
        </Col>
        <RcuControlWithChild
          Title="bathroom"
          Icon="LampOn.png"
          Device={bathroom}
          ShowDetail={bathroomShowDetail}
          Handlers={{
            turnAllOff: () => rcuControlStore.setBathroomAllOff(),
            bright: () => rcuControlStore.setBathroomBright(),
            soft: () => rcuControlStore.setBathroomSoft(),
            setShowDetail: () => rcuControlStore.setbathroomShowDetail(),
          }}
        />
      </React.Fragment>
    );
  };

  livingroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { livingroom, livingroomShowDetail } = rcuControlStore.lampControl;
    const { blindUp, blindDown } = rcuControlStore.livingRoomControl;
    const { livingroomAc } = rcuControlStore;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Living Room</div>
        </Col>
        <RcuControlWithChild
          ColSpan={24}
          Title="livingroom"
          Icon="LampOn.png"
          Device={livingroom}
          ShowDetail={livingroomShowDetail}
          Handlers={{
            turnAllOff: () => rcuControlStore.setLivingroomAllOff(),
            bright: () => rcuControlStore.setLivingroomBright(),
            soft: () => rcuControlStore.setLivingroomSoft(),
            setShowDetail: () => rcuControlStore.setlivingroomShowDetail(),
          }}
        />
        <RcuControlNoChild
          Title="blind.up"
          Icon="BlindUp.png"
          isOn={blindUp}
          onClick={() => rcuControlStore.setLivingRoomBlindUp()}
        />
        <RcuControlNoChild
          Title="blind.down"
          Icon="BlindDown.png"
          isOn={blindDown}
          onClick={() => rcuControlStore.setLivingRoomBlindDown()}
        />
        <RcuControlNoChild
          Title="ac"
          Icon="AC.svg"
          isOn={livingroomAc}
          onClick={() => rcuControlStore.setLivingroomAc()}
          ShowSwitchText={true}
        />
      </React.Fragment>
    );
  };

  bedroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { bedroom, bedroomShowDetail } = rcuControlStore.lampControl;
    const { bedroom2Ac } = rcuControlStore;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Bedroom</div>
        </Col>
        <RcuControlWithChild
          ColSpan={24}
          Title="bedroom"
          Icon="LampOn.png"
          Device={bedroom}
          ShowDetail={bedroomShowDetail}
          Handlers={{
            turnAllOff: () => rcuControlStore.setBedroomAllOff(),
            bright: () => rcuControlStore.setBedroomBright(),
            soft: () => rcuControlStore.setBedroomSoft(),
            night: () => rcuControlStore.setBedroomNight(),
            readingleft: () => rcuControlStore.setBedroomReadingLeft(),
            readingright: () => rcuControlStore.setBedroomReadingRight(),
            table: () => rcuControlStore.setBedroomTable(),
            closet: () => rcuControlStore.setBedroomCloset(),
            setShowDetail: () => rcuControlStore.setbedroomShowDetail(),
          }}
        />
        <RcuControlNoChild
          Title="ac"
          Icon="AC.svg"
          isOn={bedroom2Ac}
          onClick={() => rcuControlStore.setBedroom2Ac()}
          ShowSwitchText={true}
        />
      </React.Fragment>
    );
  };

  livingBedroomControlRender = () => {
    const { rcuControlStore } = this.props;
    const { blindUp, blindDown } = rcuControlStore.livingBedRoomControl;

    return (
      <React.Fragment>
        <Col span={24} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Living Room Bedroom</div>
        </Col>
        <RcuControlNoChild
          Title="blind.up"
          Icon="BlindUp.png"
          isOn={blindUp}
          onClick={() => rcuControlStore.setLivingBedRoomBlindUp()}
        />
        <RcuControlNoChild
          Title="blind.down"
          Icon="BlindDown.png"
          isOn={blindDown}
          onClick={() => rcuControlStore.setLivingBedRoomBlindDown()}
        />
      </React.Fragment>
    );
  };

  tableClosetControlRender = () => {
    const { rcuControlStore } = this.props;
    const { table, closet } = rcuControlStore.lampControl;

    return (
      <React.Fragment>
        <Col span={12} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Table</div>
        </Col>
        <Col span={12} style={{ paddingLeft: 8 }}>
          <div className="div-rcu-category">Closet</div>
        </Col>
        <RcuControlNoChild
          Title="table"
          Icon="LampOn.png"
          isOn={table}
          onClick={() => rcuControlStore.setTable()}
        />
        <RcuControlNoChild
          Title="closet"
          Icon="LampOn.png"
          isOn={closet}
          onClick={() => rcuControlStore.setCloset()}
        />
      </React.Fragment>
    );
  };

  render() {
    return (
      <>
        <Row className="row-rcu-menu">{this.mainControlRender()}</Row>
        <Row className="row-rcu-menu">{this.bathroomControlRender()}</Row>
        <Row className="row-rcu-menu">{this.bedroomControlRender()}</Row>
        <Row className="row-rcu-menu">{this.livingBedroomControlRender()}</Row>
        <Row className="row-rcu-menu">{this.tableClosetControlRender()}</Row>
      </>
    );
  }
}

export default RcuSmall;
